export default __webpack_public_path__ + "static/media/Boots of Vindictive Malice.f5bf9a19.jpg";